import React from "react";
import { Formik } from "formik";
import { ForgotPasswordPage } from "tabler-react";
import logo from "../../assets/img/logo.svg";
import { useHistory } from "react-router-dom";
import { Alerta } from "../../utils/Alerta";
import { useAuth } from "../../hooks/AuthContext";

export function ForgotPassword() {
  const { resetPassword } = useAuth()
  const history = useHistory();

  async function handleSubmitChangePassword(email?: string){
    try {
      if (!email) return;

      await resetPassword(email);

      history.push('/reset-password');
    } catch (err) {
      Alerta('Erro ao enviar código!');
    }
  }
  
  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
      }}
      validate={values => {
        // same as above, but feel free to move this into a class method now.
        let errors: any = {};
        if (!values.email) {
          errors.email = "Obrigatório";
        } else if (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
        ) {
          errors.email = "Endereço de e-mail inválido";
        }
        return errors;
      }}
      onSubmit={async (
        values,
        { setSubmitting, setErrors /* setValues and other goodies */ }
      ) => {
        await handleSubmitChangePassword(values.email);
      }}
      render={({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
      }) => (
        <ForgotPasswordPage
          onSubmit={handleSubmit}
          onChange={handleChange}
          onBlur={handleBlur}
          values={values}
          errors={errors}
          touched={touched}
          logoUrl={logo}
          strings={{
            title:"Esqueceu sua senha?",
            buttonText:"Enviar Código",
            emailLabel:"E-Mail",
            emailPlaceholder:"E-Mail",
            instructions: "Digite seu e-mail abaixo e enviaremos uma mensagem para redefinir sua senha "
          }}
        />
      )}
    />
  );
}
